import { AscModalDetailsPropsI } from "./AscModalDetails.type";
import styles from "./AscModalDetails.module.scss";
import AscModal from "../AscModal/AscModal";
import { GrowingChart } from "../AscIllustrations";
import AscButton from "../AscButton/AscButton";
import { CloseIcon } from "../AscIcons";

function AscModalDetails({
  visible,
  setVisible,
  title,
  description,
  list,
  withButton,
  textButton,
}: AscModalDetailsPropsI) {
  function closeModal() {
    setVisible(false);
  }

  return (
    <AscModal
      visible={visible}
      setVisible={setVisible}
      modalClassName={styles.modalClassName}
      withBackground={false}
    >
      <div className={styles.element}>
        <CloseIcon
          className={styles.closeIcon}
          onClick={closeModal}
          data-testid={"test-close-icon"}
        />
        <div className={styles.top}>
          <GrowingChart className={styles.topImage} />
        </div>
        <div className={styles.bottom}>
          <div className={styles.title}>{title}</div>
          {description && (
            <div className={styles.description}>{description}</div>
          )}

          {list && (
            <div className={styles.list}>
              {list.map((item, index) => (
                <div key={index + item} className={styles.listItem}>
                  <div className={styles.listItemCounter}>{index + 1}</div>
                  <div className={styles.listItemContent}>{item}</div>
                </div>
              ))}
            </div>
          )}

          {withButton && (
            <AscButton className={styles.button}>{textButton}</AscButton>
          )}
        </div>
      </div>
    </AscModal>
  );
}

export default AscModalDetails;
